import { render, staticRenderFns } from "./manifest-list.vue?vue&type=template&id=530e75fc"
import script from "./manifest-list.vue?vue&type=script&lang=js"
export * from "./manifest-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports